import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a003055e&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a003055e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a003055e')) {
      api.createRecord('a003055e', component.options)
    } else {
      api.reload('a003055e', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a003055e&scoped=true&", function () {
      api.rerender('a003055e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20f4MZMZR9awa/JS/comp/Accordion.vue"
export default component.exports